<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <p class="font-semibold">{{franchiseCompanyName}}</p>
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />
        <vs-spacer />
        <franchise-profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import FranchiseProfileDropDown from '../components/franchise/FranchiseProfileDropDown.vue';

export default {
  name: 'TheFranchiseNavbarVertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  data: () => ({
    franchiseCompanyName: '',
  }),
  components: {
    FranchiseProfileDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff'
        ? '#10163a'
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        'text-white':
          (this.navbarColor != '#10163a' &&
            this.$store.state.theme === 'dark') ||
          (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark'),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    // eslint-disable-next-line vue/return-in-computed-property
    classObj() {
      if (this.verticalNavMenuWidth == 'default') return 'navbar-default';
      else if (this.verticalNavMenuWidth == 'reduced') return 'navbar-reduced';
      else if (this.verticalNavMenuWidth) return 'navbar-full';
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
  created() {
    this.franchiseCompanyName = this.$store.state.AppActiveUser.companyName;

    if (this.$store.state.AppActiveUser.userType === 'subFranchise') {
      this.$store
        .dispatch(
          'franchise/fetchFranchiseDetail',
          this.$store.state.AppActiveUser.parentFranchiseId
        )
        .then(res => {
          this.franchiseCompanyName = res.data.data.companyName;
        });
    }
  },
};
</script>
